import { useState } from "react";
import { useAuth } from "@/auth/AuthContext";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { login, isAuthed, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (loading) return null;
  if (isAuthed) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main
      data-testid="admin-login-page"
      className="min-h-screen bg-[var(--bone)] flex items-center justify-center px-6"
    >
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <p className="overline">Elements Of Meaford</p>
          <h1 className="font-serif-display text-3xl md:text-4xl mt-2">
            Admin <em>sign-in</em>
          </h1>
        </div>

        <form
          data-testid="admin-login-form"
          onSubmit={onSubmit}
          className="bg-white p-8 md:p-10 border border-[var(--line)] space-y-7"
        >
          <div>
            <label className="overline">Email</label>
            <input
              required
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
              placeholder="admin@elementsofmeaford.com"
              className="input-line"
            />
          </div>
          <div>
            <label className="overline">Password</label>
            <input
              required
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password"
              placeholder="••••••••••"
              className="input-line"
            />
          </div>
          <button
            type="submit"
            disabled={submitting}
            data-testid="admin-login-submit"
            className="btn-primary w-full justify-center disabled:opacity-60"
          >
            {submitting ? (
              <>
                <Loader2 size={16} className="animate-spin" />
                Signing in…
              </>
            ) : (
              <>
                <Lock size={14} /> Sign in
              </>
            )}
          </button>
        </form>

        <p className="text-center text-xs text-[var(--ink-soft)] mt-6">
          Authorized leasing-team access only.
        </p>
      </div>
    </main>
  );
}
